<template>
  <div class="approvecen">
    <div class="approvetitle">加入凌志范儿认证</div>
    <van-grid :border="false">
     <van-grid-item :icon="img.yxlyicon" text="影响力认证" @click="goApprove" />
     <van-grid-item class="jqqd" :icon="img.default" text="敬请期待" />
     <van-grid-item class="jqqd" :icon="img.default" text="敬请期待" />
     <van-grid-item class="jqqd" :icon="img.default" text="敬请期待" />
     <van-grid-item class="jqqd" :icon="img.default" text="敬请期待" />
     <!-- <van-grid-item :icon="img.default" text="影响力认证" @click="goApprove" /> -->
     <van-grid-item class="jqqd" :icon="img.default" text="敬请期待" />
   </van-grid>
   <div class="privilege">
    <div class="f-18 f-w text-c mb-20">认证特权</div>
    <div class="privilege_info f-12">
      <van-row>
        <van-col span="12">
          <div><img :src="img.tqicon" class="tqicon">
          活动报名优先审核特权</div>
          <div style="margin-top: 12px;"><img :src="img.tqicon" class="tqicon">
          用户互动独有认证标识</div>
        </van-col>
        <van-col span="12">
          <div><img :src="img.tqicon" class="tqicon">
          商品预售优先购买特权</div>
          <div style="margin-top: 12px;"><img :src="img.tqicon" class="tqicon">
          个性化服务终身免费</div>
        </van-col>
      </van-row>
      <div class="c-gray text-c mt-25">更多专属权益敬请期待！</div>
    </div>
  </div>
</div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon,Col, Row } from 'vant';
  export default {
    data () {
      return {
        img:{
          tqicon: require('../../../assets/img/lexus/approve/tqicon.png'),
          default: require('../../../assets/img/lexus/approve/default.png'),
          hdicon: require('../../../assets/img/lexus/approve/hdicon.png'),
          sficon: require('../../../assets/img/lexus/approve/sficon.png'),
          tgicon: require('../../../assets/img/lexus/approve/tgicon.png'),
          wdicon: require('../../../assets/img/lexus/approve/wdicon.png'),
          yxlicon: require('../../../assets/img/lexus/approve/yxlicon.png'),
          yxlyicon: require('../../../assets/img/lexus/approve/yxlyicon.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.$store.dispatch('param/setToken', this.$route.query.token)
      }
      var params={
        event_code: '认证中心',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/Approvecen.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      goApprove(){
        if(this.source==9||this.source==1){
          this.$router.push({name:'LexusInvitein',params:{source:this.source,token:this.token,user_id:this.user_id}});
        }else{
          var params={
            url:this.weburl+'/lexus/invitein?source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Col.name]:Col,
      [Row.name]:Row,
      [Icon.name]:Icon
    }
  }
</script>
<style lang="scss">
  
  .approvecen{
    background-color: #F1F1F1;
    .approvetitle{
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      padding: 33px 0 18px 0;
    }
    .van-grid{
      padding: 0 20px;
      margin-bottom: 100px;
      .van-grid-item__content{
        background-color: #F1F1F1;
        .van-icon__image{
          width: 20px;
          height: 20px;
        }
        .van-grid-item__text{
          color: #3A3A3A;
        }
      }
      .jqqd{
        .van-grid-item__text{
          color: #BABABA;
        }
      }
    }
    .privilege {
      padding: 26px;
      border-top: 10px solid #F8F8F8;
      .mb-20{
        margin-bottom: 20px;
      }
      .mt-12{
        margin-top: 12px;
      }
      .mt-25{
        margin-top: 25px;
      }
      .privilege_info {
        padding: 26px 17px;
        background-color: #FFFFFF;
        .tqicon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
</style>
